import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import {InputSwitch} from 'primereact/inputswitch';
import { Message } from 'primereact/message';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Toolbar} from 'primereact/toolbar';
import {Card} from 'primereact/card';
import { useHistory, Link } from "react-router-dom";
import loader from '../loader';
import Session from '../auth/Session';
import { ProgressSpinner } from 'primereact/progressspinner';

const serverUrl = process.env.REACT_APP_SERVER_URL;

function GroupsList() {

  let [ items, setItems ] = useState([]);
  let [ display, setDisplay ] = useState('grid');
  
  let [ success, setSuccess ] = useState('');
  let [ loading, setLoading ] = useState(false);

  let history = useHistory();
  useEffect(() => {
    loader.get('/group/list', res => {
        setItems(res.items);
    }, setLoading);
  }, []);

  let updateItem = (data) => {
    const url = '/group/update';
    setLoading(true);
    setSuccess(false);
    loader.post(url, {
        method: 'POST',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify(data)
    })
    .then(res => res.json())
    .then(res => {
        setLoading(false);
        setSuccess(true);
    })
    .catch(err => {
        setLoading(false);
        console.log(err);
    });
  };

  let deleteItem = (id) => {
    const url = '/group/delete/' + id;
    setSuccess(false);
    loader.get(url, res => {
        setSuccess(true);
        items = items.filter(i => i.id !== id);
        setItems(items);
    }, setLoading);
  };

  let toggleActive = (groups, id) => {
    let items = Object.assign([], groups);
    items = items.map(item => {
        if (item.id === id) {
            item.active = !item.active;
            updateItem({ id: item.id, active: item.active });
        }
        return item;
    });
    setItems(items);
  }

  let recordOptions = (item, column) => {
    const logged = Session.getCookie();
    return <div>
        <Button
            onClick={e => history.push({ pathname: '/backoffice/groups/form/' + item.id })} 
            type="button" 
            icon="pi pi-pencil" 
            className="p-button-info"
        />
        <Button
            onClick={e => deleteItem(item.id)} 
            type="button" 
            icon="pi pi-times" 
            className="p-button-danger"
            disabled={![logged.role1].includes('ADMINISTRATOR')}
        />
    </div>;
  }

  let recordActive = (item, column) => {
    return (
        <div style={{ textAlign: 'center' }}>
            <InputSwitch 
                checked={item.active} 
                onChange={(e) => toggleActive(items, item.id)} 
            />
        </div>
    );
  }

  // Download
  const getFileUrl = (filename, folder) => {
    return filename ? serverUrl + '/download/' + folder + '/' + filename
        : '/assets/images/photo_placeholder.png';
  }

  let recordPhoto = (item, column) => {
    return (
        <img 
            src={getFileUrl(item.photo, 'groups')} 
            alt="Fotografia"
            title="Fotografia"
            className="img-avatar-mini"
        />
    )
  }

  const isMobile = window.innerWidth <= 768;
  if (loading) return <ProgressSpinner />;
  return (
    <React.Fragment>
        <div className="card card-w-title">
            <h1>Grupos</h1>

            <Toolbar>
                <div className="p-toolbar-group-left">
                    <Link to="/backoffice/groups/form/0">
                        <Button label="Inserir Novo" />
                    </Link>
                </div>
                <div className="p-toolbar-group-right">
                    <InputSwitch 
                        label="Grelha"
                        checked={display === 'grid'} 
                        onChange={(e) => setDisplay(display === 'grid' ? 'list' : 'grid')} 
                    />{' '}Grelha
                </div>
            </Toolbar>

            { success && (
                <div className="p-grid">
                    <div className="p-col-12">

                        <Message 
                            severity="success" 
                            text="O grupo foi alterado com sucesso!">
                        </Message>
                        
                    </div>
                </div>
            ) }

            { display === 'grid' ? (
                <div className="p-grid">

                    { items.map(item => (
                        <div className="p-col-6 p-lg-2" key={item.id}>
                            <Card
                                header={(
                                    <Link to={'/backoffice/groups/form/' + item.id }>
                                        <img 
                                            src={getFileUrl(item.image, 'groups')} 
                                            alt="Fotografia"
                                            title="Fotografia"
                                            className="img-avatar"
                                        />
                                    </Link>
                                )}>
                                { item.name }
                            </Card>
                        </div>
                    )) }
                    
                </div>
            ) : (
                <div className="p-grid">
                    <div className="p-col-12">

                    <DataTable value={items}>
                        <Column 
                            header="Foto"
                            body={recordPhoto}
                            style={{ textAlign: 'center' }}
                        />
                        <Column 
                            header="Nome"
                            field="name"
                            sortable={true}
                            filter={true}
                            filterMatchMode="contains"
                            style={{ textAlign: 'center' }}
                        />
                        { !isMobile && (
                            <Column 
                                header="Activo"
                                body={recordActive}
                            />
                        ) }
                        <Column 
                            header="Opções"
                            body={recordOptions}
                            style={{ textAlign: 'right' }}
                        />
                    </DataTable>
                        
                    </div>
                </div>
            ) }
            
        </div>
    </React.Fragment>
  );

}

export default GroupsList;
